/**
 *
 * @param {HTMLElement} el - parent element
 * @param {Function} callback - function to be called on parent DOM change
 * @returns {MutationObserver} - observer
 */
const onAppend = (el, callback) => {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(m => {
            if (m.addedNodes.length) {
                callback(m.addedNodes);
            }
        });
    });
    observer.observe(el, {childList: true});

    return observer;
};

export default onAppend;
